import React from 'react';
import { Card } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import TenancyInfoEnvironment from '../components/TenancyInfoEnvironment';

const TimbradoComprobanteInfo = ({ data }) => {
  return (
    <Card>
      <table className="table table-hover">
        <tbody>

          <tr>
            <td className="pr-3">Cliente id</td>
            <td>{ data.cliente_id }</td>
          </tr>

          <tr>
            <td className="pr-3">Empresa id</td>
            <td>{ data.empresa_id }</td>
          </tr>

          <tr>
            <td className="pr-3">Idx</td>
            <td>{ data.idx }</td>
          </tr>

          <tr>
            <td className="pr-3">Tenancy</td>
            <td>
              <TenancyInfoEnvironment live={ data.live } />
            </td>
          </tr>

          { Guardian.allows('root.access') && (
            <tr>
              <td>Pac</td>
              <td>{ data.pac }</td>
            </tr>
          )}

          <tr>
            <td className="pr-3">Uuid</td>
            <td>{ data.uuid }</td>
          </tr>

          <tr>
            <td className="pr-3">Intentos</td>
            <td>{ data.intentos }</td>
          </tr>

          <tr>
            <td className="pr-3">Status</td>
            <td>{ data.status }</td>
          </tr>

          <tr>
            <td className="pr-3">Tipo</td>
            <td>{ data.tipo }</td>
          </tr>

          <tr>
            <td className="pr-3">Code</td>
            <td>{ data.code }</td>
          </tr>

          <tr>
            <td className="pr-3">Reason</td>
            <td>{ data.reason }</td>
          </tr>

          <tr>
            <td className="pr-3">Emisor id</td>
            <td>{ data.emisor_id }</td>
          </tr>

          <tr>
            <td className="pr-3">Servicio</td>
            <td>{ data.servicio }</td>
          </tr>

          <tr>
            <td className="pr-3">Ciudad</td>
            <td>{ data.ciudad }</td>
          </tr>

          <tr>
            <td className="pr-3">Region</td>
            <td>{ data.region }</td>
          </tr>

          <tr>
            <td className="pr-3">Orden id</td>
            <td>{ data.orden_id }</td>
          </tr>

          <tr>
            <td className="pr-3">Grupo</td>
            <td>{ data.grupo }</td>
          </tr>

          <tr>
            <td className="pr-3">Grupo id</td>
            <td>{ data.grupo_id }</td>
          </tr>

          <tr>
            <td className="pr-3">Emisor idx</td>
            <td>{ data.emisor_idx }</td>
          </tr>

          <tr>
            <td className="pr-3">Emisor rfc</td>
            <td>{ data.emisor_rfc }</td>
          </tr>

          <tr>
            <td className="pr-3">Emisor regimen</td>
            <td>{ data.emisor_regimen }</td>
          </tr>

          <tr>
            <td className="pr-3">Emisor cp</td>
            <td>{ data.emisor_cp }</td>
          </tr>

          <tr>
            <td className="pr-3">Receptor id</td>
            <td>{ data.receptor_id }</td>
          </tr>

          <tr>
            <td className="pr-3">Receptor idx</td>
            <td>{ data.receptor_idx }</td>
          </tr>

          <tr>
            <td className="pr-3">Receptor rfc</td>
            <td>{ data.receptor_rfc }</td>
          </tr>

          <tr>
            <td className="pr-3">Serie</td>
            <td>{ data.serie }</td>
          </tr>

          <tr>
            <td className="pr-3">Folio</td>
            <td>{ data.folio }</td>
          </tr>

          <tr>
            <td className="pr-3">Fecha</td>
            <td>{ data.fecha }</td>
          </tr>

          <tr>
            <td className="pr-3">Total</td>
            <td>{ data.total }</td>
          </tr>

          <tr>
            <td className="pr-3">Subtotal</td>
            <td>{ data.subtotal }</td>
          </tr>

          <tr>
            <td className="pr-3">Descuento</td>
            <td>{ data.descuento }</td>
          </tr>

          <tr>
            <td className="pr-3">Created by</td>
            <td>{ data.created_by }</td>
          </tr>

          <tr>
            <td className="pr-3">Timbrado at</td>
            <td>{ data.timbrado_at }</td>
          </tr>

          <tr>
            <td className="pr-3">Created at</td>
            <td>{ data.created_at }</td>
          </tr>

          <tr>
            <td className="pr-3">Updated at</td>
            <td>{ data.updated_at }</td>
          </tr>

        </tbody>
      </table>
    </Card>
  )
}

export default TimbradoComprobanteInfo;